import React, { useState } from 'react'
import { FormDashboardTextarea } from '../dashboard-form'
import { Button } from '../buttons'
import { useViewport } from '../../utils'
import { useSelector } from 'react-redux'

const label = {
  en: 'Leave a Comment',
  id: 'Tinggalkan Komentar'
}

const buttonText = {
  en: 'Post Comment',
  id: 'Kirim Komentar'
}

const CommentForm = ({onSubmit = () => {}}) => {
  const { isMobile } = useViewport()
  const [comment, setComment] = useState('')
  const { language } = useSelector(state => state.system)

  const handleSubmit = (e) => {
    e.preventDefault()

    onSubmit(comment)
  }

  return (
    <div>
      <p className="text-lg font-bold mb-4">
        {label[language.name]}
      </p>
      <form onSubmit={handleSubmit}>
        <div className="mb-4 lg:mb-6">
          <FormDashboardTextarea className="w-full" onChange={e => setComment(e.target.value)}/>
        </div>
        <div className="block lg:inline-block">
          <Button
            thin={isMobile}
            className={`lg:inline-block ${isMobile ? 'w-full' : ''}`}
          >
            {buttonText[language.name]}
          </Button>
        </div>
      </form>
    </div>
  )
}

export { CommentForm }
